// body load

$(window).load(function() {
	$('body').animate({ opacity:1 },500);	
});


$(document).ready(function(){
 
  
  // Home product slider section
  $('.home_proslider').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  swipe: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        swipe: false,	
        slidesToScroll:3
      }
    },
     {
      breakpoint:767,
      settings: {
        slidesToShow:2,
        swipe: true,
        slidesToScroll: 1,
        dots: false
      }
     },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 2,
        swipe: true,
        slidesToScroll: 1,
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
}); 
  
  
    // Newsletter section
  $('#top-mc-form').ajaxChimp({
    url: ''
  });
  $('#inline-form').ajaxChimp({
    url: ''
  });
  
  
  $(".top_search, .border-bottom .search_li").click(function() {
    $(".header_search").fadeIn();
    $("#shopify-section-header").toggleClass('search_head');
    $(".announcement-bar").toggleClass('search_open');
    $('body').toggleClass('body_noscroll');
  }); 
  
  $(".search_cls").click(function() {
    $(".header_search").fadeOut();
    $("#shopify-section-header").removeClass('search_head');
    $(".announcement-bar").removeClass('search_open');
    $('body').removeClass('body_noscroll');
    
  });
  
  
    $(".site-header__cart").click(function() {
      $("#added-box-wrapper").toggleClass("showcart"); 
      $("#added-box-wrapper").slideToggle(); 
      $(".blk_tras").toggleClass('ac_blk_tras');
      $("body").addClass('body_noscroll');
      $('.mo_navigation').slideUp();
      $(".blk_tras_2").removeClass('ac_blk_tras');     
    //  $("#cart #is-a-gift").removeClass();
  
  $('.site-header__menu').removeClass('mobile-nav--close');
  $('.site-header__menu').addClass('mobile-nav--open');
  $('.mobile-nav-wrapper').removeClass('js-menu--is-open');  
    
   $(".menu_overlay").fadeOut();
       
  });  
  
  
  
  if($(window).width() < 767) {
	$(".popular_box_4").insertAfter(".popular_box_2"); 
}
  
}); 


$(window).on('load resize', function () {
  var wheight = $(window).height();
  var topsection = $('#shopify-section-header').height();
	
  $('.filmcontainer').css('height', wheight - topsection);
  
  var mobilenav = $('.mobile-nav-wrapper').height();
 // var mobilenav = $('.mobile-nav-wrapper').height();
  
  $('.new-MobileNav').css('height', mobilenav - 320);
  
});



if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/iPad/i)){
  $(document).ready(function(){    
    $('.menu_one_li a.site-nav__link').each(function() {
        var clicked = false;
        $(this).bind('click', function() {
            if(!clicked) return !(clicked = true);
        });
    });  
   
    
    $('.menu_two_li a.site-nav__link').each(function() {
        var clicked = false;
        $(this).bind('click', function() {
            if(!clicked) return !(clicked = true);
        });
    });
    
    $('.menu_three_li a.site-nav__link').each(function() {
        var clicked = false;
        $(this).bind('click', function() {
            if(!clicked) return !(clicked = true);
        });
    });
    
    $('.menu_four_li a.site-nav__link').each(function() {
        var clicked = false;
        $(this).bind('click', function() {
            if(!clicked) return !(clicked = true);
        });
    });
    
    $('.menu_five_li a.site-nav__link').each(function() {
        var clicked = false;
        $(this).bind('click', function() {
            if(!clicked) return !(clicked = true);
        });
    });
  
    $('.menu_six_li a.site-nav__link').each(function() {
        var clicked = false;
        $(this).bind('click', function() {
            if(!clicked) return !(clicked = true);
        });
    });
    
    $('.menu_seven_li a.site-nav__link').each(function() {
        var clicked = false;
        $(this).bind('click', function() {
            if(!clicked) return !(clicked = true);
        });
    });
   
    
  }); 
  
  
}